import {NumberButton} from "@FRAMEWORK/ui/desktop/button";
import {NumberInput} from "@FRAMEWORK/ui/desktop/input";
import styled from "styled-components";

const CountingWrap = styled.div`
	display: flex;
	button {
		width: 35px;
		height: 38px;

		&:before {
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
		}

		&:after {
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
		}
	}
	input {
		height: 38px;
		padding: 10px 5px;
		font-size: 15px;
	}
`;

interface IProps {
	value: number;
	minValue?: number;
	increase?: (number: number) => void;
	decrease?: (number: number) => void;
	onClick?: (trigger: string, number: number) => void;
}

const CountingButton = ({increase, decrease, onClick, value, minValue = 0}: IProps) => {
	const maxValue = 30;

	const onIncrease = () => {
		const increaseNumber = value + 1;
		typeof increase === "function" && increase(increaseNumber);
		typeof onClick === "function" && onClick("plus", increaseNumber);
	};

	const onDecrease = () => {
		const decreasedNumber = Math.max(value - 1, 0);
		typeof decrease === "function" && decrease(decreasedNumber);
		typeof onClick === "function" && onClick("minus", decreasedNumber);
	};

	return (
		<CountingWrap>
			<NumberButton types="minus" onClick={onDecrease} disabled={value <= minValue}></NumberButton>
			<NumberInput width="38px" value={value} readOnly />
			<NumberButton types="plus" onClick={onIncrease} disabled={value >= maxValue}></NumberButton>
		</CountingWrap>
	);
};

export default CountingButton;
export {CountingWrap};
